import MuiListItem, { ListItemProps as MuiListItemProps } from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import { blue } from "designSystem/styles/color";
import { HOVER, SELECTED } from "designSystem/theme";
import React, { FunctionComponent } from "react";
import { itemListStyle, navListStyle } from "designSystem/styles/style-functions";

const PREFIX = "ListItem";

interface ListItemProps extends MuiListItemProps {
	//https://github.com/mui-org/material-ui/issues/14971 
	// have to do this to avoid exception
	button?: any;

	/** variants of the list  */
	design?:
	| "list"
	| "nav";
}

const StyledListItem = styled(MuiListItem)(({
	theme,
}) => ({
	[`&.${PREFIX}list`]: {
		...itemListStyle(theme),
		[SELECTED]: {
			backgroundColor: blue[50],

			[HOVER]: {
				backgroundColor: blue[50],
			},
		},
	},
	["&.listGutters"]: {
		paddingLeft: 8,
		height: 26,
	},
	[`&.${PREFIX}nav`]: {
		...navListStyle(theme),
	},
}));

const ListItem: FunctionComponent<ListItemProps> = (props) => {
	const { design, ...otherProps } = props;
	const guttersClass = `${design}Gutters`;

	return (
		<StyledListItem
			className={`${PREFIX}${design}`}
			classes={{ gutters: guttersClass }}
			{...otherProps}
		/>
	);
};

export default ListItem;